const dictionary = {
  ko: {
    selectTotal: "선택합계",
    selectPrice: "선택단가",
    minSupplierInfo: "최저단가",

    rfqCorpId: "발신 사업자번호",
    rfqCorpName: "발신 사업자명",
    stomSubject: "발신측 제목",
    stomRemark: "발신측 요청사항",
    sendCorpId: "발신 사업자번호",

    recieveCorporationId: "발신 사업자번호",
    recieveCorporationName: "발신처",
    recieveTel: "발신 전화번호",
    recieveChargerId: "발신 담당자ID",
    recieveMessage: "메세지",
    recieveDateTime: "발신일시",
    sendMessage: "메세지",
    paymentTerms: "결제조건",
    message: "메세지",
    "수발주 리스트1": "수발주 리스트",
    purchaseCorpName: "매입처",
    purchaseCorpId: "매입처Id",
    상세내역: "상세내역",
    품목내역: "품목내역",
    견적의뢰: "견적의뢰",
    기반코드: "기반코드",
    선박코드: "선박코드",
    코드관리: "코드관리",
    Language: "언어",
    검색: "검색",
    조회: "조회",
    삭제: "삭제",
    "저장되었습니다.": "저장 되었습니다",
    "삭제 되었습니다.": "삭제 되었습니다.",
    "견적서 목록": "견적서 목록",
    "삭제 하시겠습니까?": "삭제 하시겠습니까?",
    "견적서 상세내역": "견적서 상세내역",
    state: "상태",
    area: "지역",
    arrivalDateTime: "입항일시",
    arriveDateTime: "입항일시",
    bareBoatDivision: "나용 구분",
    bareBoatDivisionName: "나용 구분 이름",
    baseAddress: "주소",
    beforeShipCallSign: "전 선박 호출부호",
    businessCondition: "업태",
    buyerItemCode: "구매자 ItemCode",
    buyerItemName: "구매자 품목명",
    callClassName: "호출 클래스명",
    callMethodName: "호출 메소드명",
    captainTel: "선장 연락처",
    ceoName: "대표이름",
    chargerAssignDateTime: "담당자 할당 일시",
    chargerEmail: "담당자 메일",
    chargerFax: "담당자 팩스",
    chargerId: "담당자ID",
    chargerMobile: "담당자 핸드폰",
    chargerName: "담당자 이름",
    chargerPhone: "담당자 전화",
    classCode: "분류 코드",
    classCodeId: "분류 코드ID",
    classItem: "종목",
    className: "분류 이름",
    clientCode: "거래처 코드",
    clientCorporationRegisterNumber: "거래처 사업자 등록 번호",
    clientId: "거래처ID",
    clientName: "거래처 회사 이름",
    confirmDateTime: "승인일시",
    confirmId: "승인자ID",
    confirmRequestDateTime: "승인요청일시",
    constructionnDate: "건조 일자",
    content: "컨텐츠",
    corpId: "사업자등록번호",
    corporationChargerTel: "업체 담당자 연락처",
    corporationEmail: "회사 이메일",
    corporationFax: "회사 팩스",
    corporationName: "회사명",
    corporationPhone: "회사 전화",
    corporationReferenceId: "회사ID",
    createDateTime: "생성 일시",
    createId: "생성ID",
    currency: "통화",
    currencyCode: "통화 코드",
    currencyName: "통화 이름",
    currencySign: "통화 기호",
    customsCode: "관세청 코드",
    deadWeightTonnage: "재화 중량톤수",
    decimalPoint: "소수점",
    deleteDateTime: "삭제 일시",
    deliveryRequestDateTime: "납품요청일시",
    deliveryRequestDateTime: "납품 요청 일시",
    departureDateTime: "출항 일시",
    detailAddress: "상세 주소",
    detailCode: "상세 코드",
    detailCodeName: "상세 코드 이름",
    documentDivision: "문서 구분",
    documentId: "문서ID",
    documentName: "문서명",
    documentNumber: "문서 번호",
    documentPhase: "문서 단계",
    documentReferenceId: "참조문서ID",
    documentStatus: "문서 상태",
    documentSubject: "문서제목",
    emailLogId: "메일 로그ID",
    entityName: "테이블_명",
    etc: "ETC",
    exchangeRate: "환 율",
    faxPageCount: "FAX 본수",
    fieldName: "필드_명",
    fileId: "파일ID",
    fileName: "파일 이름",
    filePath: "파일 경로",
    fileSize: "파일 용량",
    fullDraft: "만재흘수",
    gridConfig: "그리드 설정",
    gridName: "그리드 이름",
    grossTonnage: "총톤수",
    groupCode: "그룹 코드",
    groupCodeId: "그룹 코드ID",
    groupCodeName: "그룹 코드 이름",
    haborDivision: "외내항 구분",
    haborDivisionName: "외내항 구분 이름",
    hsCode: "HS 코드",
    hullNumber: "선체 번호",
    id: "ID",
    imoNumber: "IMO번호",
    impaCode: "IMPA 코드",
    inspectionOrganization: "검사 기관",
    internationalGrossTonnage: "국제 총톤수",
    isOilTankerDoubleHull: "유조선 이중선체 여부",
    isSbtStructure: "SBT 구조 여부",
    isSend: "전송 여부값",
    isSync: "과금기준일시",
    itemCode: "품목 코드",
    itemName: "품목 이름",
    keyFormat: "KEY_포멧",
    languageDivision: "언어 구분",
    lastInspectionDate: "최종 검사 일자",
    lastInspectionInformation: "최종 검사 정보",
    loadDate: "선적 일자",
    loadPortCode: "선적 항 코드",
    loadPortName: "선적 항 명",
    loadPortNationalityCode: "선적 항 국적 코드",
    logDivision: "로그 구분",
    logReferenceId: "로그 참조ID",
    maker: "메이커",
    menuDivision: "메뉴 구분",
    menuId: "메뉴ID",
    menuName: "메뉴 이름",
    menuUrl: "메뉴 URL",
    mmsiNumber: "MMSI 번호",
    multiLanguageDivision: "다국어 코드",
    nationalityCode: "국적 코드",
    nationalityName: "국적 이름",
    netTonnage: "순톤수",
    nextInspectionDate: "차기 검사 일자",
    nextInspectionType: "차기 검사 종류",
    operatorCorporationCode: "운영자 업체 코드",
    operatorCorporationName: "운영자 업체 이름",
    operatorNationalityCode: "운영자 국적 코드",
    operatorNationalityName: "운영자 국적 이름",
    orderDateTime: "발주일자",
    originCompareDate: "원본 대조 일자",
    pageCode: "화면 코드",
    pageDivision: "화면 구분",
    pageId: "화면ID",
    pageName: "화면 이름",
    pageUrl: "화면 URL",
    pageUrlPath: "화면 URL 경로",
    parentId: "부모ID",
    partNumber: "파트 번호",
    partNumber: "파트번호",
    pid: "부모ID",
    popbillResultCode: "결과코드",
    popbillSendRequestNumber: "전송요청 번호",
    portCode: "항구 코드",
    portName: "항구 이름",
    postCode: "우편 코드",
    price: "단가",
    priceForeignCurrency: "단가 외화",
    productDivision: "물품 구분",
    purchaseCorpCode: "매입 업체 코드",
    purchaseCorporationId: "매입 업체 ID",
    purchaseCorporationName: "매입 업체 이름",
    purchaseExchangeRate: "매입 환 율",
    purchaseItemCode: "매입 품목 코드",
    purchaseItemName: "매입 품목 이름",
    quantity: "수량",
    quotationExpiredDateTime: "견적 마감 일시",
    quotationValidDate: "견적유효일자",
    receiveChargerId: "수신 담당자ID",
    receiveCorporationId: "매입처 업체ID",
    receiveCorporationName: "수신자명",
    receiveDateTime: "수신 일시",
    receiveDivision: "수신 구분",
    receiveNumber: "수신번호",
    receiveUserEmail: "수신 사용자 메일",
    receiveUserId: "수신 사용자ID",
    receiverEmail: "수신자 이메일",
    receiverId: "수신자ID",
    receiverMessage: "전달사항",
    receiverName: "수신자명",
    referenceDivision: "참조구분",
    referenceDocumentNumber: "참조번호",
    referenceId: "참조ID",
    referenceNumber: "참조번호",
    referenceVersion: "참조버전",
    rejectDateTime: "거절일시",
    rejectReason: "거절사유",
    remark: "비고",
    replaceItemCode: "대체ItemCode",
    replaceItemName: "대체품목명",
    replyDate: "회신일자",
    requestDateTime: "요청 일시",
    requestId: "요청ID",
    roundDivision: "반올림 구분",
    sailForm: "운항 형태",
    sailFormName: "운항 형태 이름",
    saleExchangeRate: "매매 환율",
    selectPrice: "선택단가",
    minPrice: "최저단가",
    sendDateTime: "송신일시",
    sendMonth: "월",
    sendYear: "년도",
    senderId: "송신자 ID",
    senderMessage: "전달사항",
    senderName: "송신자 이름",
    sequenceNumber: "seq",
    shipAgentCode: "대리점코드",
    shipAgentName: "선사/대리점 이름",
    shipAgentTel: "선사/대리점 연락처",
    shipCallSign: "선박 호출 부호",
    shipDepth: "선박 깊이",
    shipInformationRegisterDate: "선박 정보 등록일자",
    shipLength: "선박 길이",
    shipName: "선박 이름",
    shipNameEn: "선박 이름 영문",
    shipNationality: "선박 국적",
    shipNationalityCode: "선박 국적 코드",
    shipNumber: "선박 번호",
    shipOwnerCorporationCode: "선주 업체 코드",
    shipOwnerCorporationName: "선주 업체 이름",
    shipOwnerNationalityCode: "선주 국적 코드",
    shipOwnerNationalityName: "선주 국적 이름",
    shipTel: "선박 연락처",
    shipTotalLength: "선박 총길이",
    shipType: "선박 종류",
    shipTypeName: "선박 종류 이름",
    shipUniqueKey: "선박 고유 키",
    shipWidth: "선박 너비",
    specification: "규격",
    state: "엔티티상태",
    subject: "제목",
    supplierSignature: "공급자 부호",
    system: "시스템",
    systemCode: "시스템 코드",
    systemName: "시스템명",
    tableName: "테이블 이름",
    target: "대상",
    tonnageCertificateDivision: "톤수 증서 구분",
    total: "합계",
    totalForeignCurrency: "합계 외화",
    transactionDivision: "트랜잭션 구분",
    transportContractCondition: "운송계약조건",
    unit: "단위",
    unitAlt: "변경단위",
    updateDateTime: "수정 일시",
    updateId: "수정ID",
    userId: "사용자ID",
    value: "값",
    vatDivision: "부가세 구분",
    version: "버전",
    volume: "부피",
    weight: "중량",
    writeDate: "작성 일자",
  },

  en: {
    selectTotal: "선택합계",
    selectPrice: "선택단가",
    minSupplierInfo: "최저단가",

    rfqCorpId: "발신 사업자번호",
    rfqCorpName: "발신 사업자명",
    stomSubject: "발신측 제목",
    stomRemark: "발신측 요청사항",
    sendCorpId: "발신 사업자번호",

    recieveCorporationId: "발신 사업자번호",
    recieveCorporationName: "발신처",
    recieveTel: "발신 전화번호",
    recieveChargerId: "발신 담당자ID",
    recieveMessage: "메세지",
    recieveDateTime: "발신일시",
    sendMessage: "메세지",
    paymentTerms: "결제조건",
    message: "메세지",
    "수발주 리스트1": "수발주 리스트",
    purchaseCorpName: "매입처",
    purchaseCorpId: "매입처Id",
    상세내역: "상세내역",
    품목내역: "품목내역",
    견적의뢰: "견적의뢰",
    기반코드: "기반코드",
    선박코드: "선박코드",
    코드관리: "코드관리",
    Language: "언어",
    검색: "검색",
    조회: "조회",
    삭제: "삭제",
    "저장되었습니다.": "저장 되었습니다",
    "삭제 되었습니다.": "삭제 되었습니다.",
    "견적서 목록": "견적서 목록",
    "삭제 하시겠습니까?": "삭제 하시겠습니까?",
    "견적서 상세내역": "견적서 상세내역",
    state: "상태",
    area: "지역",
    arrivalDateTime: "입항일시",
    arriveDateTime: "입항일시",
    bareBoatDivision: "나용 구분",
    bareBoatDivisionName: "나용 구분 이름",
    baseAddress: "주소",
    beforeShipCallSign: "전 선박 호출부호",
    businessCondition: "업태",
    buyerItemCode: "구매자 ItemCode",
    buyerItemName: "구매자 품목명",
    callClassName: "호출 클래스명",
    callMethodName: "호출 메소드명",
    captainTel: "선장 연락처",
    ceoName: "대표이름",
    chargerAssignDateTime: "담당자 할당 일시",
    chargerEmail: "담당자 메일",
    chargerFax: "담당자 팩스",
    chargerId: "담당자ID",
    chargerMobile: "담당자 핸드폰",
    chargerName: "담당자 이름",
    chargerPhone: "담당자 전화",
    classCode: "분류 코드",
    classCodeId: "분류 코드ID",
    classItem: "종목",
    className: "분류 이름",
    clientCode: "거래처 코드",
    clientCorporationRegisterNumber: "거래처 사업자 등록 번호",
    clientId: "거래처ID",
    clientName: "거래처 회사 이름",
    confirmDateTime: "승인일시",
    confirmId: "승인자ID",
    confirmRequestDateTime: "승인요청일시",
    constructionnDate: "건조 일자",
    content: "컨텐츠",
    corpId: "사업자등록번호",
    corporationChargerTel: "업체 담당자 연락처",
    corporationEmail: "회사 이메일",
    corporationFax: "회사 팩스",
    corporationName: "회사명",
    corporationPhone: "회사 전화",
    corporationReferenceId: "회사ID",
    createDateTime: "생성 일시",
    createId: "생성ID",
    currency: "통화",
    currencyCode: "통화 코드",
    currencyName: "통화 이름",
    currencySign: "통화 기호",
    customsCode: "관세청 코드",
    deadWeightTonnage: "재화 중량톤수",
    decimalPoint: "소수점",
    deleteDateTime: "삭제 일시",
    deliveryRequestDateTime: "납품요청일시",
    deliveryRequestDateTime: "납품 요청 일시",
    departureDateTime: "출항 일시",
    detailAddress: "상세 주소",
    detailCode: "상세 코드",
    detailCodeName: "상세 코드 이름",
    documentDivision: "문서 구분",
    documentId: "문서ID",
    documentName: "문서명",
    documentNumber: "문서 번호",
    documentPhase: "문서 단계",
    documentReferenceId: "참조문서ID",
    documentStatus: "문서 상태",
    documentSubject: "문서제목",
    emailLogId: "메일 로그ID",
    entityName: "테이블_명",
    etc: "ETC",
    exchangeRate: "환 율",
    faxPageCount: "FAX 본수",
    fieldName: "필드_명",
    fileId: "파일ID",
    fileName: "파일 이름",
    filePath: "파일 경로",
    fileSize: "파일 용량",
    fullDraft: "만재흘수",
    gridConfig: "그리드 설정",
    gridName: "그리드 이름",
    grossTonnage: "총톤수",
    groupCode: "그룹 코드",
    groupCodeId: "그룹 코드ID",
    groupCodeName: "그룹 코드 이름",
    haborDivision: "외내항 구분",
    haborDivisionName: "외내항 구분 이름",
    hsCode: "HS 코드",
    hullNumber: "선체 번호",
    id: "ID",
    imoNumber: "IMO번호",
    impaCode: "IMPA 코드",
    inspectionOrganization: "검사 기관",
    internationalGrossTonnage: "국제 총톤수",
    isOilTankerDoubleHull: "유조선 이중선체 여부",
    isSbtStructure: "SBT 구조 여부",
    isSend: "전송 여부값",
    isSync: "과금기준일시",
    itemCode: "품목 코드",
    itemName: "품목 이름",
    keyFormat: "KEY_포멧",
    languageDivision: "언어 구분",
    lastInspectionDate: "최종 검사 일자",
    lastInspectionInformation: "최종 검사 정보",
    loadDate: "선적 일자",
    loadPortCode: "선적 항 코드",
    loadPortName: "선적 항 명",
    loadPortNationalityCode: "선적 항 국적 코드",
    logDivision: "로그 구분",
    logReferenceId: "로그 참조ID",
    maker: "메이커",
    menuDivision: "메뉴 구분",
    menuId: "메뉴ID",
    menuName: "메뉴 이름",
    menuUrl: "메뉴 URL",
    mmsiNumber: "MMSI 번호",
    multiLanguageDivision: "다국어 코드",
    nationalityCode: "국적 코드",
    nationalityName: "국적 이름",
    netTonnage: "순톤수",
    nextInspectionDate: "차기 검사 일자",
    nextInspectionType: "차기 검사 종류",
    operatorCorporationCode: "운영자 업체 코드",
    operatorCorporationName: "운영자 업체 이름",
    operatorNationalityCode: "운영자 국적 코드",
    operatorNationalityName: "운영자 국적 이름",
    orderDateTime: "발주일자",
    originCompareDate: "원본 대조 일자",
    pageCode: "화면 코드",
    pageDivision: "화면 구분",
    pageId: "화면ID",
    pageName: "화면 이름",
    pageUrl: "화면 URL",
    pageUrlPath: "화면 URL 경로",
    parentId: "부모ID",
    partNumber: "파트 번호",
    partNumber: "파트번호",
    pid: "부모ID",
    popbillResultCode: "결과코드",
    popbillSendRequestNumber: "전송요청 번호",
    portCode: "항구 코드",
    portName: "항구 이름",
    postCode: "우편 코드",
    price: "단가",
    priceForeignCurrency: "단가 외화",
    productDivision: "물품 구분",
    purchaseCorpCode: "매입 업체 코드",
    purchaseCorporationId: "매입 업체 ID",
    purchaseCorporationName: "매입 업체 이름",
    purchaseExchangeRate: "매입 환 율",
    purchaseItemCode: "매입 품목 코드",
    purchaseItemName: "매입 품목 이름",
    quantity: "수량",
    quotationExpiredDateTime: "견적 마감 일시",
    quotationValidDate: "견적유효일자",
    receiveChargerId: "수신 담당자ID",
    receiveCorporationId: "매입처 업체ID",
    receiveCorporationName: "수신자명",
    receiveDateTime: "수신 일시",
    receiveDivision: "수신 구분",
    receiveNumber: "수신번호",
    receiveUserEmail: "수신 사용자 메일",
    receiveUserId: "수신 사용자ID",
    receiverEmail: "수신자 이메일",
    receiverId: "수신자ID",
    receiverMessage: "전달사항",
    receiverName: "수신자명",
    referenceDivision: "참조구분",
    referenceDocumentNumber: "참조번호",
    referenceId: "참조ID",
    referenceNumber: "참조번호",
    referenceVersion: "참조버전",
    rejectDateTime: "거절일시",
    rejectReason: "거절사유",
    remark: "비고",
    replaceItemCode: "대체ItemCode",
    replaceItemName: "대체품목명",
    replyDate: "회신일자",
    requestDateTime: "요청 일시",
    requestId: "요청ID",
    roundDivision: "반올림 구분",
    sailForm: "운항 형태",
    sailFormName: "운항 형태 이름",
    saleExchangeRate: "매매 환율",
    selectPrice: "선택단가",
    minPrice: "최저단가",
    sendDateTime: "송신일시",
    sendMonth: "월",
    sendYear: "년도",
    senderId: "송신자 ID",
    senderMessage: "전달사항",
    senderName: "송신자 이름",
    sequenceNumber: "seq",
    shipAgentCode: "대리점코드",
    shipAgentName: "선사/대리점 이름",
    shipAgentTel: "선사/대리점 연락처",
    shipCallSign: "선박 호출 부호",
    shipDepth: "선박 깊이",
    shipInformationRegisterDate: "선박 정보 등록일자",
    shipLength: "선박 길이",
    shipName: "선박 이름",
    shipNameEn: "선박 이름 영문",
    shipNationality: "선박 국적",
    shipNationalityCode: "선박 국적 코드",
    shipNumber: "선박 번호",
    shipOwnerCorporationCode: "선주 업체 코드",
    shipOwnerCorporationName: "선주 업체 이름",
    shipOwnerNationalityCode: "선주 국적 코드",
    shipOwnerNationalityName: "선주 국적 이름",
    shipTel: "선박 연락처",
    shipTotalLength: "선박 총길이",
    shipType: "선박 종류",
    shipTypeName: "선박 종류 이름",
    shipUniqueKey: "선박 고유 키",
    shipWidth: "선박 너비",
    specification: "규격",
    state: "엔티티상태",
    subject: "제목",
    supplierSignature: "공급자 부호",
    system: "시스템",
    systemCode: "시스템 코드",
    systemName: "시스템명",
    tableName: "테이블 이름",
    target: "대상",
    tonnageCertificateDivision: "톤수 증서 구분",
    total: "합계",
    totalForeignCurrency: "합계 외화",
    transactionDivision: "트랜잭션 구분",
    transportContractCondition: "운송계약조건",
    unit: "단위",
    unitAlt: "변경단위",
    updateDateTime: "수정 일시",
    updateId: "수정ID",
    userId: "사용자ID",
    value: "값",
    vatDivision: "부가세 구분",
    version: "버전",
    volume: "부피",
    weight: "중량",
    writeDate: "작성 일자",
  },

  en1: {
    "수발주 리스트1": "list of",
    문서번호: "Doc No.",
    제목: "Subject",
    상태: "State",
    작성일자: "Write DT",
    메모: "Memo",
    선박: "Ship",
    문서정보: "Document Info",
    상세내역: "상세내역",
    품목내역: "ITEM",
    견적의뢰: "RFQ",
    selectTotal: "Total",
    selectPrice: "select price",
    minSupplierInfo: "min price",
    기반코드: "Basic Code",
    선박코드: "Ship Code",
    코드관리: "Code Management",
    Language: "Language",
    조회: "Search",
    검색: "Search",
    삭제: "Delete",
    "저장되었습니다.": "The document has been saved",
    "삭제 되었습니다.": "The document has been deleted",
    "견적서 목록": "List of quotes",
    "삭제 하시겠습니까?": "Are you sure you want to delete?",
    "견적서 상세내역": "Quote details",
    state: "상태",
    area: "지역",
    arrivalDateTime: "입항일시",
    arriveDateTime: "입항일시",
    bareBoatDivision: "나용 구분",
    bareBoatDivisionName: "나용 구분 이름",
    baseAddress: "주소",
    beforeShipCallSign: "전 선박 호출부호",
    businessCondition: "업태",
    buyerItemCode: "구매자 ItemCode",
    buyerItemName: "구매자 품목명",
    callClassName: "호출 클래스명",
    callMethodName: "호출 메소드명",
    captainTel: "선장 연락처",
    ceoName: "대표이름",
    chargerAssignDateTime: "담당자 할당 일시",
    chargerEmail: "담당자 메일",
    chargerFax: "담당자 팩스",
    chargerId: "담당자ID",
    chargerMobile: "담당자 핸드폰",
    chargerName: "담당자 이름",
    chargerPhone: "담당자 전화",
    classCode: "분류 코드",
    classCodeId: "분류 코드ID",
    classItem: "종목",
    className: "분류 이름",
    clientCode: "거래처 코드",
    clientCorporationRegisterNumber: "거래처 사업자 등록 번호",
    clientId: "거래처ID",
    clientName: "거래처 회사 이름",
    confirmDateTime: "승인일시",
    confirmId: "승인자ID",
    confirmRequestDateTime: "승인요청일시",
    constructionnDate: "건조 일자",
    content: "컨텐츠",
    corpId: "사업자등록번호",
    corporationChargerTel: "업체 담당자 연락처",
    corporationEmail: "회사 이메일",
    corporationFax: "회사 팩스",
    corporationName: "회사명",
    corporationPhone: "회사 전화",
    corporationReferenceId: "회사ID",
    createDateTime: "생성 일시",
    createId: "생성ID",
    currency: "통화",
    currencyCode: "통화 코드",
    currencyName: "통화 이름",
    currencySign: "통화 기호",
    customsCode: "관세청 코드",
    deadWeightTonnage: "재화 중량톤수",
    decimalPoint: "소수점",
    deleteDateTime: "삭제 일시",
    deliveryRequestDateTime: "납품요청일시",
    deliveryRequestDateTime: "납품 요청 일시",
    departureDateTime: "출항 일시",
    detailAddress: "상세 주소",
    detailCode: "상세 코드",
    detailCodeName: "detailCodeName",
    documentDivision: "documentDivision",
    documentId: "문서ID",
    documentName: "문서명",
    documentNumber: "documentNumber",
    documentPhase: "문서 단계",
    documentReferenceId: "참조문서ID",
    documentStatus: "documentStatus",
    documentSubject: "문서제목",
    emailLogId: "메일 로그ID",
    entityName: "테이블_명",
    etc: "ETC",
    exchangeRate: "환 율",
    faxPageCount: "FAX 본수",
    fieldName: "필드_명",
    fileId: "파일ID",
    fileName: "파일 이름",
    filePath: "파일 경로",
    fileSize: "파일 용량",
    fullDraft: "만재흘수",
    gridConfig: "그리드 설정",
    gridName: "그리드 이름",
    grossTonnage: "총톤수",
    groupCode: "그룹 코드",
    groupCodeId: "그룹 코드ID",
    groupCodeName: "그룹 코드 이름",
    haborDivision: "외내항 구분",
    haborDivisionName: "외내항 구분 이름",
    hsCode: "HS 코드",
    hullNumber: "선체 번호",
    id: "ID",
    imoNumber: "IMO번호",
    impaCode: "IMPA 코드",
    inspectionOrganization: "검사 기관",
    internationalGrossTonnage: "국제 총톤수",
    isOilTankerDoubleHull: "유조선 이중선체 여부",
    isSbtStructure: "SBT 구조 여부",
    isSend: "전송 여부값",
    isSync: "과금기준일시",
    itemCode: "Code",
    itemName: "ItemName",
    keyFormat: "KEY_포멧",
    languageDivision: "언어 구분",
    lastInspectionDate: "최종 검사 일자",
    lastInspectionInformation: "최종 검사 정보",
    loadDate: "선적 일자",
    loadPortCode: "선적 항 코드",
    loadPortName: "선적 항 명",
    loadPortNationalityCode: "선적 항 국적 코드",
    logDivision: "로그 구분",
    logReferenceId: "로그 참조ID",
    maker: "메이커",
    menuDivision: "메뉴 구분",
    menuId: "메뉴ID",
    menuName: "메뉴 이름",
    menuUrl: "메뉴 URL",
    mmsiNumber: "MMSI 번호",
    multiLanguageDivision: "다국어 코드",
    nationalityCode: "국적 코드",
    nationalityName: "국적 이름",
    netTonnage: "순톤수",
    nextInspectionDate: "차기 검사 일자",
    nextInspectionType: "차기 검사 종류",
    operatorCorporationCode: "운영자 업체 코드",
    operatorCorporationName: "운영자 업체 이름",
    operatorNationalityCode: "운영자 국적 코드",
    operatorNationalityName: "운영자 국적 이름",
    orderDateTime: "발주일자",
    originCompareDate: "원본 대조 일자",
    pageCode: "화면 코드",
    pageDivision: "화면 구분",
    pageId: "화면ID",
    pageName: "화면 이름",
    pageUrl: "화면 URL",
    pageUrlPath: "화면 URL 경로",
    parentId: "부모ID",
    partNumber: "파트 번호",
    partNumber: "파트번호",
    pid: "부모ID",
    popbillResultCode: "결과코드",
    popbillSendRequestNumber: "전송요청 번호",
    portCode: "항구 코드",
    portName: "항구 이름",
    postCode: "우편 코드",
    price: "단가",
    priceForeignCurrency: "단가 외화",
    productDivision: "물품 구분",
    purchaseCorpCode: "매입 업체 코드",
    purchaseCorporationId: "매입 업체 ID",
    purchaseCorporationName: "매입처",
    purchaseExchangeRate: "매입 환 율",
    purchaseItemCode: "매입 품목 코드",
    purchaseItemName: "매입 품목 이름",
    quantity: "수량",
    quotationExpiredDateTime: "견적 마감 일시",
    quotationValidDate: "견적유효일자",
    receiveChargerId: "수신 담당자ID",
    receiveCorporationId: "매입처 업체ID",
    receiveCorporationName: "수신자명",
    receiveDateTime: "수신 일시",
    receiveDivision: "수신 구분",
    receiveNumber: "수신번호",
    receiveUserEmail: "수신 사용자 메일",
    receiveUserId: "수신 사용자ID",
    receiverEmail: "수신자 이메일",
    receiverId: "수신자ID",
    receiverMessage: "수신자 전달사항",
    receiverName: "수신자 이름",
    referenceDivision: "참조구분",
    referenceDocumentNumber: "참조 문서번호",
    referenceId: "참조ID",
    referenceNumber: "참조번호",
    referenceVersion: "참조 버전",
    rejectDateTime: "거절 일시",
    rejectReason: "거절 사유",
    remark: "비고",
    replaceItemCode: "대체 품목 코드",
    replaceItemName: "대체 품목 명",
    replyDate: "회신일자",
    requestDateTime: "요청 일시",
    requestId: "요청ID",
    roundDivision: "반올림 구분",
    sailForm: "운항 형태",
    sailFormName: "운항 형태 이름",
    saleExchangeRate: "매매 환 율",
    selectPrice: "selected unit price",
    minPrice: "min unit price",
    sendDateTime: "송신일시",
    sendMonth: "월",
    sendYear: "년도",
    senderId: "송신자 ID",
    senderMessage: "송신자 전달사항",
    senderName: "송신자 이름",
    sequenceNumber: "seq",
    shipAgentCode: "선사/대리점 코드",
    shipAgentName: "선사/대리점 이름",
    shipAgentTel: "선사/대리점 연락처",
    shipCallSign: "선박 호출 부호",
    shipDepth: "선박 깊이",
    shipInformationRegisterDate: "선박 정보 등록일자",
    shipLength: "선박 길이",
    shipName: "선박 이름",
    shipNameEn: "선박 이름 영문",
    shipNationality: "선박 국적",
    shipNationalityCode: "선박 국적 코드",
    shipNumber: "선박 번호",
    shipOwnerCorporationCode: "선주 업체 코드",
    shipOwnerCorporationName: "선주 업체 이름",
    shipOwnerNationalityCode: "선주 국적 코드",
    shipOwnerNationalityName: "선주 국적 이름",
    shipTel: "선박 연락처",
    shipTotalLength: "선박 총길이",
    shipType: "선박 종류",
    shipTypeName: "선박 종류 이름",
    shipUniqueKey: "선박 고유 키",
    shipWidth: "선박 너비",
    specification: "규격",
    specification: "규격",
    state: "엔티티상태",
    subject: "제목",
    supplierSignature: "공급자 부호",
    system: "시스템",
    systemCode: "시스템 코드",
    systemName: "시스템명",
    tableName: "테이블 이름",
    target: "대상",
    tonnageCertificateDivision: "톤수 증서 구분",
    total: "합계",
    totalForeignCurrency: "합계 외화",
    transactionDivision: "트랜잭션 구분",
    transportContractCondition: "운송계약조건",
    unit: "unit",
    unitAlt: "변경단위",
    updateDateTime: "수정일시",
    updateId: "수정ID",
    userId: "사용자ID",
    value: "값",
    vatDivision: "부가세 구분",
    version: "버전",
    volume: "부피",
    weight: "중량",
    writeDate: "작성 일자",
  },

  de: {
    Number: "Nummer",
    Contact: "Ansprechpartner",
    Company: "Firma",
    Amount: "Betrag",
    PaymentDate: "Zahlungsdatum",
  },
  ru: {
    Number: "Номер",
    Contact: "Имя",
    Company: "Организация",
    Amount: "Сумма",
    PaymentDate: "Дата оплаты",
  },

  de: {
    Number: "Nummer",
    Contact: "Ansprechpartner",
    Company: "Firma",
    Amount: "Betrag",
    PaymentDate: "Zahlungsdatum",
  },
  ru: {
    Number: "Номер",
    Contact: "Имя",
    Company: "Организация",
    Amount: "Сумма",
    PaymentDate: "Дата оплаты",
  },
};

const locales = [
  {
    Name: "English",
    Value: "en",
  },

  {
    Name: "한국어",
    Value: "ko",
  },
];

export default {
  getLocales() {
    return locales;
  },
  getDictionary() {
    return dictionary;
  },
};
